export default __webpack_public_path__ + "static/media/brasil.c178bb8c.svg";